import { getGlobals } from "src/consts/globals";
import { useCookieBotConsentReady } from "src/hooks/cookie-bot/use-cookie-bot-consent-ready";

export const useCanRunVwoExperiments = (): boolean => {
    const isCookieBotConsentReady = useCookieBotConsentReady();
    return getGlobals()?.isVwoEnabled && isCookieBotConsentReady && Boolean(window?.Cookiebot?.consent.statistics);
};
